import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import './App.css';
/* Shared order-history shell (Spot Orders, Open Orders, ~8 similar profile pages) */
import './ui/Pages/SpotOrders/spotOrders.css';
import Routing from './Routing'
import Loading from './customComponents/Loading';
import LoaderHelper from './customComponents/Loading/LoaderHelper';
import { ProfileProvider } from './context/ProfileProvider';
import { PlatformStatusProvider } from './context/PlatformStatusProvider';
import { Toaster } from 'react-hot-toast';
import SocketContextProvider from './customComponents/SocketContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { prefetchSpotExchangeInfo } from './customComponents/Libraries/TVChartContainer/helpers';
import HeaderSearchModal from "./customComponents/HeaderSearchModal";

function App() {
  useEffect(() => {
    prefetchSpotExchangeInfo();
  }, []);

  useEffect(() => {
    const MODAL_SELECTOR = [
      ".withdraw_confirm_overlay",
      ".withdraw-kyc-gate-overlay",
      ".passkey-modal-overlay",
      ".ev-modal-overlay",
      ".ca-modal-overlay",
      ".pm-restrictOverlay",
      ".agce-ao-detail-backdrop",
      ".buy-sell-page__currencyPickerOverlay",
      ".buy-sell-page__payOverlay",
      ".convert-page__coinModalOverlay",
      ".convert-page__planModalOverlay",
      ".convert-page__investSheetOverlay",
      ".mobile-favourites-popup-overlay",
      ".market-quote-select-mobile-overlay",
      ".popup-overlay",
      ".orders-mrp",
      ".acct-modalOverlay",
      // About Us team profile modal
      ".agc_profile_modal_overlay",
      // Bootstrap modals/offcanvas (e.g. Deposit -> Select Coin)
      ".modal.show",
      ".modal-backdrop.show",
      ".offcanvas.show",
      // Deposit custom overlay (Select Network)
      ".deposit_select_network_overlay",
    ].join(",");

    const runUpdate = () => {
      const anyOpen = Boolean(document.querySelector(MODAL_SELECTOR));

      // Lock scroll WITHOUT layout shift (no padding-right compensation).
      // We must read scrollY BEFORE applying position: fixed (which resets scroll to 0).
      if (anyOpen) {
        if (!document.body.dataset.agceScrollY) {
          document.body.dataset.agceScrollY = String(window.scrollY || 0);
          document.body.style.top = `-${document.body.dataset.agceScrollY}px`;
        }
      }

      document.body.classList.toggle("agce-modal-open", anyOpen);
      document.documentElement.classList.toggle("agce-modal-open", anyOpen);

      if (!anyOpen && document.body.dataset.agceScrollY) {
        const y = Number.parseInt(document.body.dataset.agceScrollY, 10) || 0;
        delete document.body.dataset.agceScrollY;
        document.body.style.top = "";
        window.scrollTo(0, y);
      }
    };

    let rafId = 0;
    const scheduleUpdate = () => {
      if (rafId) return;
      rafId = requestAnimationFrame(() => {
        rafId = 0;
        runUpdate();
      });
    };

    runUpdate();
    const obs = new MutationObserver(scheduleUpdate);
    obs.observe(document.body, { childList: true, subtree: true, attributes: true });
    window.addEventListener("resize", scheduleUpdate);
    return () => {
      if (rafId) cancelAnimationFrame(rafId);
      obs.disconnect();
      window.removeEventListener("resize", scheduleUpdate);
      document.body.classList.remove("agce-modal-open");
      document.documentElement.classList.remove("agce-modal-open");
      if (document.body.dataset.agceScrollY) {
        const y = Number.parseInt(document.body.dataset.agceScrollY, 10) || 0;
        delete document.body.dataset.agceScrollY;
        window.scrollTo(0, y);
      }
      document.body.style.top = "";
    };
  }, []);

  return (
    <GoogleOAuthProvider clientId="488257125358-7m1dbuf7531gq43mjdi1q5qef0fqia11.apps.googleusercontent.com">
      <PlatformStatusProvider>
        <ProfileProvider>
          {createPortal(
            <Toaster
              position="top-right"
              containerClassName="agce-global-toaster"
              toastOptions={{
                duration: 2500,
                style: {
                  background: '#2b313c',
                  color: '#e0e0e0',
                  fontSize: '14px',
                },
              }}
              containerStyle={{
                top: 20,
                right: 20,
                zIndex: 2147483647,
              }}
            />,
            document.body
          )}

          <SocketContextProvider>
            <Routing />
            <HeaderSearchModal />
            <Loading ref={ref => LoaderHelper.setLoader(ref)} />
          </SocketContextProvider>
        </ProfileProvider>
      </PlatformStatusProvider>
    </GoogleOAuthProvider>


  )
};

export default App;